<template>
  <div>
    <form role="form">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                Affichage à l'écran
              </h3>

            </div>
            <form method="POST" action="" @submit.prevent="refreshListing()">
              <div class="box-body">
                <div class="row">
                  <div class="col-md-12">
                    <label>A afficher :</label>
                    <div class="form-group">
                      <label class="checkbox-inline">
                        <input id="memberLicencies" type="checkbox"
                               v-model="show.memberLicencies">
                        Membres licenciés
                      </label>
                      <label class="checkbox-inline">
                        <input id="memberNotLicencies" type="checkbox"
                               v-model="show.memberNotLicencies">
                        Membres non-licenciés
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-footer">
                <input type="submit" value="Rechercher" class="btn btn-primary pull-right"/>
              </div>
            </form>
          </div>
        </div>
      </div>
    </form>

    <form role="form">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="overlay" v-if="loadingTableBox">
              <i class="fa fa-refresh fa-spin"></i>
            </div>

            <div class="box-header with-border">
              <h3 class="box-title">Membres (accès QR Code): ({{ licencesQueried.length }} résultats / {{
                  licencesQueried.length -
                  nombreDoublons
                }} doublons)</h3>


              <div class="btn-group pull-right">
                <button @click.prevent="exportCSV()" type="button" class="btn btn-primary"
                        :disabled="licencesChecked.length==0" :class="{'disabled':licencesChecked.length==0}">Exporter
                  en XLS/CSV (Excel)
                </button>
                <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"
                        :disabled="licencesChecked.length==0" :class="{'disabled':licencesChecked.length==0}">
                  <span class="caret"></span>
                  <span class="sr-only">Dropdown</span>
                </button>
                <ul class="dropdown-menu dropdown-menu-abft" role="menu">
                  <li><a @click.prevent="exportCSV()">Exporter en XLS/CSV (Excel)</a></li>
                </ul>
              </div>

              <div class="btn-group margin-r-5 pull-right">
                <button :disabled="licencesQueried.length==0" :class="{'disabled':licencesQueried.length==0}"
                        @click.prevent="selectAll()" type="button" class="btn btn-default">Sélectionner tout
                </button>
                <button :disabled="licencesQueried.length==0" :class="{'disabled':licencesQueried.length==0}"
                        type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">
                  <span class="caret"></span>
                  <span class="sr-only">Dropdown</span>
                </button>
                <ul class="dropdown-menu" role="menu">
                  <li><a @click.prevent="selectAll()">Sélectionner tout</a></li>
                  <li><a @click.prevent="deselectAll()">Déselectionner tout</a></li>
                </ul>
              </div>
            </div>
            <div class="box-body">
              <table v-if="true" id="listingMembresMyABFT"

                     class="table table-hover table-striped table-bordered">
                <thead>
                <tr>
                  <th></th>
                  <th>Licence</th>
                  <th>Nom</th>
                  <th>Prénom</th>
                  <th>Téléphone</th>
                  <th>Mail</th>
                  <th>Statut</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="membre in licencesQueried" :key="membre.id">
                  <td><input type="checkbox" :value="membre.id" v-model="licencesChecked"></td>
                  <td>{{ membre.numlicenceABFT }}</td>

                  <td>
                    <router-link :to="{ name: 'Member', params: { member_id: membre.id }}">{{ membre.nom }}</router-link>
                  </td>
                  <td>
                    <router-link :to="{ name: 'Member', params: { member_id: membre.id }}">{{ membre.prenom }}</router-link>
                  </td>
                  <td>{{ membre.phoneContact }}</td>
                  <td><a v-if="membre.mail" :href="'mailto:'+membre.mail">{{ membre.mail }}</a><span v-else>-</span></td>
                  <td v-if="membre.isLicencie"><span class="text-green">Licencié au {{ currentYear() }}</span></td>
                  <td v-else><span class="text-red">Non-licencié au {{ currentYear() }}</span></td>
                  <td>
                    <button @click.prevent="" class="btn btn-box-tool">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button @click.prevent="" class="btn btn-box-tool">
                      <i class="fa fa-remove"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';

import vueTableListingMembreInClub from '../VueTable/configs/vueTableListingMembreInClub'

var $ = require('jquery');
var variables = require('../../assets/js/variables')
var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');

export default {
  data() {
    return {
      licencesQueried: [],
      licencesChecked: [],
      nombreDoublons: 0,
      dataTable: null,
      loadingTableBox: false,
      show: {
        memberLicencies: true,
         memberNotLicencies: true,
         canScanQrCode: true
      }
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
    }),

  },
  methods: {
    ...mapActions({}),

    getTimeStamp: function (date) {
      return moment(date).valueOf()
    },
    selectAll: function () {
      this.licencesChecked = [];
      this.licencesChecked = this.licencesQueried.map(function (item) {
        return item.id
      });
    },
    deselectAll: function () {
      this.licencesChecked = [];
    },
    moment: function () {
      return moment()
    },
    exportCSV: function () {
      if (this.licencesChecked.length <= 0)
        return;
      let these = this;
      this.loadingTableBox = true
      this.$http.post(this.getRoute('exportListingMembresXLS'), JSON.stringify({selection: this.licencesChecked}), {responseType: 'blob'})
        .then(function (response) {
          var blob = new Blob([response.body], {type: 'application/vnd.ms-excel'});
          FileSaver.saveAs(blob, "exportListingMembres.xls");
          this.loadingTableBox = false
          return response.blob();
        }, (response) => {
          these.$noty.error("Erreur dans la génération de l'export")
          this.loadingTableBox = false
        });
    },
    setDoublons: function () {
      let result = {}
      this.licencesQueried.forEach(function (item, index, array) {
        result[item.id] = true
      })
      this.nombreDoublons = _.keys(result).length
    },
    currentYear: function () {
      return moment().format("DD/MM/YYYY");
    },
    constructForm: function () {
      return JSON.stringify({
        "memberLicencies": this.show.memberLicencies,
        "memberNotLicencies": this.show.memberNotLicencies,
        "canScanQrCode": this.show.canScanQrCode,
      })
    },
    formatDate: function (value, ftmIn, fmtOut) {
      if (value == null) return ''
      fmtOut = (typeof fmtOut == 'undefined') ? 'DD/MM/YYYY HH:mm' : fmtOut
      return moment(value, ftmIn).format(fmtOut)
    },
    refreshListing: function () {
      var these = this
      this.$http.post(this.getRoute('MyABFTIntranet.ListingMembresRequestForMyABFTIntranet'), this.constructForm()).then(function (response) {
        // Détruire l'instance DataTable existante avant mise à jour
        if (these.dataTable) {
          try {
            these.dataTable.clear().destroy();
          } catch (e) {
            // au cas où l'instance ne soit pas encore initialisée correctement
          }
          these.dataTable = null;
        }
        // Mettre à jour les données Vue (réactif)
        these.licencesQueried = Object.values(response.body);
        these.licencesChecked = [];
        these.setDoublons();
        // Réinitialiser DataTable après rendu du DOM
        these.$nextTick(function () {
          these.dataTable = $("#listingMembresMyABFT").DataTable({
            language: variables.dt_french(),
            "paging": true,
            "ordering": true,
            "info": true,
            "autoWidth": true,
          });
        });
      }, (response) => {
        these.$noty.error("Erreur la requête pour le listing des membres")
      })
    }
  },
  watch: {},

  mounted: function () {
    var these = this
    these.dataTable = null;
    this.$nextTick(function () {
      these.refreshListing();
    })
  },
  filters: {},
  components: {}
}
</script>





// WEBPACK FOOTER //
// src/components/MyABFT/ListingMembresMyABFT.vue